import { render } from "./ViewDashboard.vue?vue&type=template&id=47e79c96&scoped=true"
import script from "./ViewDashboard.vue?vue&type=script&lang=js"
export * from "./ViewDashboard.vue?vue&type=script&lang=js"

import "./ViewDashboard.vue?vue&type=style&index=0&id=47e79c96&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e79c96"]])

export default __exports__